module.exports = __webpack_public_path__ + "static/_thumb_73928.df80a515.png";